import { STATUSPAGE } from '@repo/ui';
import { HandleStudentsWithoutRegisteringApp } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import {
  clearStudentsWithoutRegisteringApp,
  loadStudentsWithoutRegisteringApp,
} from 'presentation/config/store/reports/students-without-registering-app-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useStudentsWithoutRegisteringApp = () => {
  // service
  const { reportService } = useService();
  const dispatch = useDispatch();

  // States
  const [loading, setLoading] = useState<STATUSPAGE>(STATUSPAGE.DONE);
  const [selectedSubmitBtn, setSelectedSubmitBtn] = useState<string>();
  const [hasFetchedData, setHasFetchedData] = useState(false);

  // Methods PDF-EXCEL
  const requestHandleStudentsWithoutRegisteringApp = useCallback(
    (params: HandleStudentsWithoutRegisteringApp.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleStudentsWithoutRegisteringApp(params)
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/${params?.type === 0 ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  // Methods JSON
  const requestHandleStudentsWithoutRegisteringAppJson = useCallback(
    (params: HandleStudentsWithoutRegisteringApp.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleStudentsWithoutRegisteringApp(params)
        .then((res: any) => {
          dispatch(loadStudentsWithoutRegisteringApp(res));
        })
        .catch((err) => {
          notifyError(err.message);
          dispatch(clearStudentsWithoutRegisteringApp(null));
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
          setHasFetchedData(true);
        });
    },
    [],
  );
  return {
    loading,
    hasFetchedData,
    selectedSubmitBtn,
    setSelectedSubmitBtn,
    requestHandleStudentsWithoutRegisteringApp,
    requestHandleStudentsWithoutRegisteringAppJson,
  };
};
